var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 127,
    viewBox: "0 0 127 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 127,
    height: 127,
    rx: 13,
    fill: "#042440"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.2405 40.76L95.1703 55.3473L95.1721 55.3538L99.0494 69.9031C99.64 72.1193 99.0189 74.4827 97.4151 76.1222L87.0215 86.7475L76.1066 97.4289C74.4728 99.0278 72.1192 99.6509 69.9083 99.0699L55.087 95.175L55.0755 95.1719L40.7635 91.2612C38.5547 90.6577 36.8264 88.9364 36.2137 86.7301L32.1027 71.9247L28.3792 57.4918C27.8197 55.3231 28.4161 53.0191 29.9576 51.3943L40.5271 40.2538L51.4077 29.9415C53.0267 28.407 55.3195 27.8099 57.4814 28.3598L72.1987 32.1034L86.726 36.1941C88.93 36.8147 90.6449 38.5491 91.2405 40.76Z",
    stroke: "white",
    strokeWidth: 5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0ee3d67db9efd3d30bc977142a051436.svg";
export { ForwardRef as ReactComponent };